import UrlUtils from "../utils/url";

export default {
  data() {
    return {
      host: "",
      isMaasAuth: false,
      isUserTypeFree: false,
      applicationConfig: {
        service: {},
        investment: {},
        usageService: {},
      },
      salSelfHosts: [
        "sal.morningstar.com",
        "sal-uat.morningstar.com",
        "sal-stg.morningstar.com",
        "sal-dev.morningstar.com",
        "sal-qa.morningstar.com",
        "pdfportal-uat.psp2049d.eas.morningstar.com",
        "localhost:8080"
      ],
      expiresTime: 3600,
    };
  },
  computed: {},
  created() {
    // eslint-disable-next-line no-undef
    this.version = `VERSION  ${morningstar.components["@pdf/core"].version}`;
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { host } = window.location;
      this.host = host;
      this.authType = this.getParameterByName("authType", location.hash);
      this.isMaasAuth =
        this.authType &&
        this.authType === "maas";

      this.setAuthenticationKey(host);
      this.applicationConfig.service.tokenRealtime =
        this.getRTToken();

      const serviceBaseUrl = this.getServiceBase(host);
      this.applicationConfig.service.baseUrl = serviceBaseUrl;

      const baseUrl = this.getHost(host);
      this.applicationConfig.usageService.baseUrl = `${baseUrl}/log/index.html`;

      this.setSALContentType();
      this.setIfFreeUser();
      this.addSalEventSecurityClickListener();
      this.setHttpWithCredentialsForAWS(host);
      window.sal.configuration.setAppConfig(this.applicationConfig);

      if (this.isMaasAuth) {
        this.intervalSetMaasToken();
      }
    },
    getParameterByName(name, target) {
      const newName = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp(`[\\?&]${newName}=([^&#]*)`);
      const results = regex.exec(target || location.search);
      const result = results && results[1] && results[1].length > 0;

      return !result
        ? undefined
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    getRTToken() {
      let token = this.getParameterByName("e");

      token = token || this.getParameterByName("e", location.hash);
      const tokenMapping = {
        nonProd:
          "eyJlbmMiOiJBMTI4R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.eVhdZlOob3znMHs0CBh1yhJW5YtlWJOhCLJIMx-EEl-i7qRuWMhfRSgAQsvPCyq9yktBDPrxc3IZrfmpPcvol-OJXvuhUQjTrtClEFYp4h9YADkZ79Sqlxn7m8IouUI1fi4ywavm9dG6bnXL2AdR99RQt-Or_UFdpyBKD3h_0R0.pJWDC_PCryKjKYjh.0GHUH4V6SepZcFemicnbvMnGy7Oskcpfb8UzxJpy-lKxRcH-UGpmu_b511ESxjk57lJQtef7KBD0SxD0Ty9LJAF6BOiAusfBsRWLCMolUI_oL9D5-zpOYLccMBcGFe33qkCZSFPNcbYeZ88LMZdX0-olkQpZm0HxY7HB5WLSj9lx64ZTNv1x7Gt9-StdeSyckZot4A1Boz_eSK4KBwhMvNlJwV_1v0xbY5k20tM.NGN6X1CeVVCzpJ8iPAzW3g",
        prod: "eyJlbmMiOiJBMTI4R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.eVhdZlOob3znMHs0CBh1yhJW5YtlWJOhCLJIMx-EEl-i7qRuWMhfRSgAQsvPCyq9yktBDPrxc3IZrfmpPcvol-OJXvuhUQjTrtClEFYp4h9YADkZ79Sqlxn7m8IouUI1fi4ywavm9dG6bnXL2AdR99RQt-Or_UFdpyBKD3h_0R0.pJWDC_PCryKjKYjh.0GHUH4V6SepZcFemicnbvMnGy7Oskcpfb8UzxJpy-lKxRcH-UGpmu_b511ESxjk57lJQtef7KBD0SxD0Ty9LJAF6BOiAusfBsRWLCMolUI_oL9D5-zpOYLccMBcGFe33qkCZSFPNcbYeZ88LMZdX0-olkQpZm0HxY7HB5WLSj9lx64ZTNv1x7Gt9-StdeSyckZot4A1Boz_eSK4KBwhMvNlJwV_1v0xbY5k20tM.NGN6X1CeVVCzpJ8iPAzW3g",
      };
      let tokenTemp = tokenMapping.nonProd;
      if ([0, 1, 2, 3, 4, 5, 6].indexOf(this.salSelfHosts.indexOf(this.host)) > -1) {
        tokenTemp = tokenMapping.prod;
      }
      return token || tokenTemp;
    },
    getApiEndpoint() {
      if (this.isMaasAuth) {
        return 'sal/sal-service';
      }
      return 'sal-service';
    },
    getApiHost(host) {
      if ([0].indexOf(this.salSelfHosts.indexOf(host)) > -1) {
        return "https://api-global.morningstar.com";
      }
      if (host.indexOf("sal-stg.morningstar.com") > -1) {
        return "https://api-stg.morningstar.com";
      }
      if (host.indexOf("sal-dev.morningstar.com") > -1) {
        return "https://api-dev.morningstar.com";
      }
      if (host.indexOf("sal-qa.morningstar.com") > -1) {
        return "https://api-qa.morningstar.com";
      }
      if (host.indexOf("sal-uat.morningstar.com") > -1) {
        return "https://api-uat.morningstar.com";
      }
      return "https://api-stg.morningstar.com";
    },
    getMaasHost(host) {
      if (host.indexOf("pdfportal-qa.psp98d75.easn.morningstar.com") > -1 
      || host.indexOf("pdfportal-dev.psp98d75.easn.morningstar.com") > -1 
      || host.indexOf("pdfportal-stg.psp98d75.easn.morningstar.com") > -1) {
        return "https://www.us-stg-api.morningstar.com";
      }else if(host.indexOf("pdfportal-uat.psp2049d.eas.morningstar.com")>-1){
                return "https://www.us-uat-api.morningstar.com";
      }else if(host.indexOf("pdfportal-prod.psp2049d.eas.morningstar.com")>-1){
                return "https://www.us-api.morningstar.com";
      }
      return "https://www.us-stg-api.morningstar.com";
    },
    getServiceBase(host) {
      const apiHost = this.isMaasAuth
        ? this.getMaasHost(host)
        : this.getApiHost(host);
      let serviceVersion = apiHost.indexOf("https://api") > -1 ? "/v1/" : "/";
      const endPoint = this.getApiEndpoint();
      const serviceBase = `${apiHost}/${endPoint}${serviceVersion}`;
      return serviceBase;
    },
    setHttpWithCredentialsForAWS(host) {
      if (host.indexOf("easn.morningstar.com") > -1) {
        this.applicationConfig.service.httpWithCredentials = false;
      }
    },
    getHost(host) {
      if (
        [0, 1, 2, 3, 4, 5, 6].indexOf(this.salSelfHosts.indexOf(host)) > -1 ||
        host === this.WEB_DEV_SERVER
      ) {
        return `${location.protocol}//${host}`;
      }
      return `${location.protocol}//${this.salSelfHosts[4]}`;
    },
    setSALContentType() {
      let userType = this.getParameterByName("userType", location.hash);
      userType = userType && userType.toLowerCase();

      if (
        location.hash.indexOf("-premium") > 0 ||
        location.hash.indexOf("-institution") > 0 ||
        userType === "premium"
      ) {
        this.applicationConfig.service.salContentType =
          "nNsGdN3REOnPMlKDShOYjlk6VYiEVLSdpfpXAm7o2Tk=";
      } else {
        this.applicationConfig.service.salContentType =
          "e7FDDltrTy+tA2HnLovvGL0LFMwT+KkEptGju5wXVTU=";
      }
    },
    setIfFreeUser() {
      if (location.hash.indexOf("-free") > 0) {
        this.isUserTypeFree = true;
      }
    },
    // for OAuth
    setAuthenticationKey(host) {
      if (this.authType === "oauth" || this.isMaasAuth) {
        this.getAcessToken(host, this.authType).done((jsonData) => {
          if (jsonData.access_token) {
            if (this.authType === "oauth") {
              this.applicationConfig.service.tokenOAuth2 =
                jsonData.access_token;
            } else {
              this.applicationConfig.service.tokenMaaS =
                jsonData.access_token;
              this.expiresTime = jsonData.expires_in;
            }
          }
        });
      }
    },
    getAcessToken(host, authType) {
      const svcEntry = this.getAccessTokenEndpoint(host, authType);
      return $.ajax({
        type: "GET",
        url: svcEntry,
        async: false,
        dataType: "json",
      });
    },
    getAccessTokenEndpoint(host, authType) {
      const type = authType === "maas" ? "maas" : "api";
      let newHost = host.includes("localhost") ? "salservice-stg.morningstar.com" : host;
      if(host.includes("pdfportal-dev.psp98d75.easn.morningstar.com")){
        newHost = "salservice-stg.morningstar.com";
      }else if (host.includes("pdfportal-qa.psp98d75.easn.morningstar.com")) {
        newHost = "salservice-stg.morningstar.com";  
      }else if (host.includes("pdfportal-stg.psp98d75.easn.morningstar.com")) {
        newHost = "salservice-stg.morningstar.com";
      } else if (host.includes("pdfportal-uat.psp2049d.eas.morningstar.com")) {
        newHost = "salservice-uat.morningstar.com";
      } else if (host.indexOf("pdfportal-prod.psp2049d.eas.morningstar.com")>-1){
        newHost = "salservice.morningstar.com";
      }
      return `https://${newHost}/sal-service/security/${type}/session`;
    },
    intervalSetMaasToken() {
      setInterval(() => {
        const promise = this.getAcessToken(this.host, "maas");
        promise.done((jsonData) => {
          if (jsonData.access_token) {
            this.applicationConfig.service.tokenMaaS =
              jsonData.access_token;
            window.sal.configuration.setAppConfig(this.applicationConfig);
          }
        });
      }, this.expiresTime * 1000);
    },
  
    addSalEventSecurityClickListener() {
      document.addEventListener("sal.event.security.click", (event) => {
        event.stopImmediatePropagation();
        if (event.detail.type !== "hyperlink") {
          return;
        }

        const currentReportSecurityType = this.getParameterByName(
          "securityType",
          location.hash
        );

        UrlUtils.launchReport(event, currentReportSecurityType);
      });
    },
  },
};
